<template>
  <div class="collection-book">
    <div class="book-card">
      <div class="book-data">
        <div>
          <img
            class="book-cover"
            alt="中医古籍"
            data-warden-title="显示文章内容"
            :data-warden-info="book.bookName"
              :data-warden-bookId="book.bookId"
            :src="book.image"
            @click="gotoBookDetail(book)"
          />
        </div>
        <div class="book-info">
          <div class="title">
            <span class="book-name" data-warden-title="显示文章内容" :data-warden-info="book.bookName"
              :data-warden-bookId="book.bookId" @click="gotoBookDetail(book)">{{ book.name }}</span>
            <img src="../assets/images/icons/star1.png" class="star-icon"
              @click="handleDeleteCollect" title="取消收藏" />
          </div>
          <div class="info-list">
            <div class="book-intro">
              <img class="book-icon" src="../assets/images/icons/witer.png" />
              <span class="book-title">著者</span>
              <b>:</b>
              <span class="book-content">{{ book.author }}</span>
            </div>
            <div class="book-intro">
              <img class="book-icon" src="../assets/images/SearchPage/folder.png" />
              <span class="book-title">分类</span>
              <b>:</b>
              <span class="book-content">{{ book.class }}</span>
            </div>
            <div class="book-intro">
              <img class="book-icon" src="../assets/images/icons/year.png" />
              <span class="book-title">成书年</span>
              <b>:</b>
              <span class="book-content">{{ book.year }}</span>
            </div>
            <div class="book-intro">
              <img class="book-icon" src="../assets/images/icons/version.png" />
              <span class="book-title">版本</span>
              <b>:</b>
              <span class="book-content">{{ book.edition }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="position">
        <img class="position-icon" src="../assets/images/icons/position.png" />
        <span>馆藏地：</span>
        <span v-html="book.position"></span>
      </div>
    </div>
    <button class="view-note" data-warden-title="显示文章内容" :data-warden-info="book.bookName"
              :data-warden-bookId="book.bookId" @click="openNote(book)">
      <img
        :src="require('@/assets/images/userPage/eye.png')"
        alt="查看笔记"
        class="icon"
      />
      查看笔记
    </button>
    <button class="tool-button" data-warden-title="显示文章内容" :data-warden-info="book.bookName"
              :data-warden-bookId="book.bookId" @click="gotoBookDetail(book)">继续读书</button>
  </div>
</template>

<script>
export default {
  name: 'CollectionBook',
  props: {
    book: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {}
  },
  methods: {
    gotoBookDetail (item) {
      let userId = localStorage.getItem('userId')
      let pageId = 1
      let url = 'retrieve/storeBook/getBookPage?userId=' + userId + '&bookId=' + item.bookId
      console.log('bookId:', item.bookId)
      this.$http.get(url).then(
        res => {
          pageId = Number(res.data.data)
          // console.log(pageId)
          let pathInfo = '/bookDetail'
          if (this.$route.params.url) {
            pathInfo = '/' + this.$route.params.url + pathInfo
          }
          let routeUrl = this.$router.resolve({
            path: pathInfo,
            query: { book: item.bookId, page: pageId }
          })
          window.open(routeUrl.href, '_blank')
        },
        err => {
          console.log(err)
          let pathInfo = '/bookDetail'
          if (this.$route.params.url) {
            pathInfo = '/' + this.$route.params.url + pathInfo
          }
          let routeUrl = this.$router.resolve({
            path: pathInfo,
            query: { book: item.bookId }
          })
          window.open(routeUrl.href, '_blank')
        })
    // console.log(pageId)
    },
    openNote (item) {
      let userId = localStorage.getItem('userId')
      let pageId = 1
      let url = 'retrieve/storeBook/getBookPage?userId=' + userId + '&bookId=' + item.bookId
      console.log('bookId:', item.bookId)
      this.$http.get(url).then(
        res => {
          pageId = Number(res.data.data)
        },
        err => {
          console.log(err)
        })
      console.log(pageId)
      let pathInfo = '/bookDetail'
      if (this.$route.params.url) {
        pathInfo = '/' + this.$route.params.url + pathInfo
      }
      let routeUrl = this.$router.resolve({
        path: pathInfo,
        query: {book: item.bookId, note: true}
      })
      window.open(routeUrl.href, '_blank')
    },
    handleDeleteCollect () {
      this.$emit('deleteCollect', this.book.bookId)
    }
  }
}
</script>

<style scoped>
.collection-book {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0 10px;
  margin: 8px;
}

.book-card {
  background-color: #fff;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  padding-bottom: 8px;
  width: 285px;
  height: 190px;
}
.book-data {
  display: grid;
  grid-template-columns: 1fr 2fr;
}
.book-cover {
  width: 95px;
  height: 140px;
  margin: 5px;
  margin-top: 8px;
  float: left;
}
.title{
  margin-top: 5px;
  text-align: left;
}
.book-name {
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
  cursor: pointer;
}
.star-icon {
  width: 25px;
  margin-right: 8px;
  position: relative;
  top: 2px;
  float: right;
}
.info-list{
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.book-intro {
  margin-left: 2px;
  font-size: 14px;
  text-align: left;
}
.book-icon {
  width: 16px;
  height: 16px;
  position: relative;
  top: 2px;
}
.book-title {
  margin-top: 2px;
  width: 45px;
  display: inline-block;
  text-align-last: justify;
}
.position {
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  color: #a29c95;
  margin-top: 18px;
}

.position-icon {
  width: 15px;
  height: 15px;
  position: relative;
  top: 2px;
}

.icon {
  width: 23px;
  margin-right: 5px;
}

.view-note {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  color: #634c37;
  margin-top: 5px;
  border: 0;
  background-color: transparent;
}

.tool-button {
  border: 0;
  width: 108px;
  height: 29px;
  font-size: 12px;
  background-color: #9e5c1d;
  color: #fff;
  margin-top: 5px;
  cursor: pointer;
}
.delete-collect {
  display: none;
}
.book-card:hover .delete-collect{
  display: block;
  position: absolute;
  top: 0px;
  width: 140px;
  height: 30px;
  text-align: right;
/* background-color: rgba(255, 255, 255, 0.2); */
}
</style>



// WEBPACK FOOTER //
// src/components/CollectionBooks.vue